export default __webpack_public_path__ + "static/media/TL05.3d079d1e.mp3";